import { useEffect, useState } from "react"
import { useScope } from "../SelectProjectCompanyContainer"
import Send from "../../core/communication"
import DynamicDashScreen from "../../screen/DynaminDashScreen"
import { sort } from "fast-sort"
import moment from "moment"
import { useNavigate } from "react-router-dom"
import { ChartRepository } from "../../core/repository/ChartRepository"
import { useUsers } from "../../core/utils/hooks/useUsers"
import { getIds } from "../../core/utils/getIds"
import { useSelector } from "react-redux"
import { useDWOptions } from "../../core/utils/hooks/useDwOptions"
import { customToast } from "../../components/Toast"
import { formatData } from "../DashboardContainer"
import { useFormProject } from "../../core/utils/hooks/useFormProject"

const shortcuts = {
  ["332bdca8-6c13-4ae6-af99-8df8c4fc787d"]: [
    { formId: "4c08ba2c-1688-4d00-b3bc-294442776b6d", title: "Acompanhamento Mensal - Fase 1" },
    { formId: "d621fb77-0adc-4504-a993-da6334282e87", title: "Acompanhamento Mensal - Fase 2" },
    { formId: "f4ae2078-9ecf-4e89-8513-c01da14932cb", title: "Acompanhamento Mensal - Fase 3" },
    { formId: "a31d81ac-f116-43c7-a8ce-8d74028e797a", title: "Plano de Vida Rural - Fase 1" },
    { formId: "d4e38889-fc0f-4b98-affe-d0a8a7976484", title: "Plano de Vida Rural - Fase 2" },
    { formId: "093e2602-437f-4f83-9f24-226d321fa1d2", title: "Plano de Vida Rural - Fase 3" },
  ],
}

const periodOptions = [
  { value: "Year", label: "Ano" },
  { value: "Month", label: "Mês" },
  { value: "Week", label: "Semana" },
  { value: "Day", label: "Dia" },
]

const dataGroupOptions = [
  { value: "all", name: "Normal" },
  { value: "medium", name: "Média" },
  { value: "sum", name: "Soma" },
  { value: "min", name: "Mínima" },
  { value: "max", name: "Máxima" },
  { value: "first", name: "Primeiro" },
  { value: "last", name: "Último" },
]

const castAnswer = (castType, answer) => {
  switch (castType) {
    case "age":
      return ChartRepository.dateToAge(moment(answer, "DD/MM/YYYY").format("YYYY-MM-DD"))
    default:
      return answer
  }
}

export const pivot = (arr) => {
  const o = arr.reduce((a, b) => {
    a[b.ID] = a[b.ID] || []
    // && item.ID_Questao_unica === b.ID_Questao_unica
    const data = arr.filter(
      (item) => item.ID === b.ID && item.Pergunta_codigo === b.Pergunta_codigo,
    )
    a[b.ID].push({
      [b.Pergunta_codigo]: data.length === 1 ? b.Resposta : data.map((item) => item.Resposta),
    })
    return a
  }, {})

  const a = Object.keys(o).map(function (k) {
    const data = { ...arr.find((item) => item.ID === k) }

    delete data.Resposta
    delete data.Pergunta_codigo

    return {
      ...data,
      realInicio: data.Inicio,
      Inicio: moment(data.Inicio).format("DD/MM/YYYY"),
      ...Object.assign.apply({}, o[k]),
    }
  })

  return sort(a).desc("realInicio")
}

const inFilter = (item, component, filter) => {
  let isInFilter = true

  component.columns &&
    component.columns.map((column) => {
      if (isInFilter && filter[column] && item[column] !== filter[column]) {
        isInFilter = false
      }
    })

  return isInFilter
}

const formatFields = (dw, component, filter) => {

  const formatDate = (item) => {
    const date = moment(item?.Inicio, [
      "YYYY-MM-DD",
      "YYYY-MM-DDTHH:mm:ssZ",
      "DD/MM/YYYY",
    ]).toDate();

    const Mes = item?.Mes || String(date.getMonth() + 1).padStart(2, "0");
    const Ano = item?.Ano || date.getFullYear();

    return { Mes, Ano };
  };
  console.log("aqui --------------")

  console.log({dw})

  const pivotted = pivot(
    dw.map(item => ({
      ...item,
      ...formatDate(item),
      Atendimento: item.ID,
      ID: `${item.ID}${item.Pergunta_codigo}`
    })).filter(
      (item) =>
        (component.codes && component.codes.find((a) => a.code === item.Pergunta_codigo)) ||
        (component.codes && component.codes.find((a) => a.codes?.includes(item.Pergunta_codigo))) ||
        (component.code && component.code === item.Pergunta_codigo),
    ),
    component,
  )

  return pivotted.map((item) => {
    const isInFilter = inFilter(item, component, filter)
    let castFields = {}
    component?.codes.map((code) => {
      if (code.cast) {
        castFields = { ...castFields, [code.code]: castAnswer(code?.cast, item[code?.code]) }
      }
    })

    return {
      ...item,
      ...castFields,
      inFilter: isInFilter,
    }
  })
}

const getLastUniqueItems = (arr) => {
  const seen = new Map()

  arr.forEach((item) => {
    seen.set(item, item)
  })

  return Array.from(seen.values())
}

const formattDw = (dw, filter, jsonConfig) => {
  let newConfig = jsonConfig.map(({ components, ...config }) => {
    return {
      ...config,
      components: components
        .map((component) => {
          const formattedFields = formatFields(dw, component, filter).map((item) => ({
            ...item,
            [item.Pergunta_codigo_1]: Array.isArray(item[item.Pergunta_codigo_1])
              ? getLastUniqueItems(item[item.Pergunta_codigo_1])
              : item[item.Pergunta_codigo_1],
          }))

          return {
            ...component,
            fields: formattedFields,
          }
        })
        .filter((component) => Array.isArray(component.fields) && component.fields.length > 0),
    }
  })

  return newConfig
}

const DynamicDashContainer = (props) => {
  const dashId = window.location.href.split("/")[5]
  const navigate = useNavigate()

  // Função para carregar filtros salvos do localStorage
  const loadSavedFilters = () => {
    try {
      const savedFilters = localStorage.getItem(`dynamicDash_filters_${dashId}`)
      if (savedFilters) {
        return JSON.parse(savedFilters)
      }
    } catch (error) {
      console.log("Erro ao carregar filtros salvos:", error)
    }
    return {
      period: null,
      date: null,
      reference: null,
      aggregationType: null,
      producer: [],
      tec: [],
      referenceForm: null,
      form: null,
    }
  }

  const [filter, setFilter] = useState(loadSavedFilters())
  const isUserAdmin = useSelector((state) => state.app?.isUserAdmin)
  const { scope, scopeType, projectsByScope } = useScope()
  const { users } = useUsers()
  const [dw, setDw] = useState([])
  const { forms: formsByProject } = useFormProject()
  const [dwReference, setDwReference] = useState([])
  const [settingsIsOpen, setSettingsIsOpen] = useState(false)
  const [loadingData, setLoadingData] = useState(false)
  const [currentComponent] = useState(null)
  const [usersTec, setUsersTec] = useState([])
  const [isShortcutsModalOpen, setIsShortcutsModalOpen] = useState(false)
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [comparisonFields, setComparisonFields] = useState([])
  const [dwComparison] = useDWOptions()

  // Estados para controle de busca manual
  const [isInitialLoad, setIsInitialLoad] = useState(true)
  const [hasFiltersChanged, setHasFiltersChanged] = useState(false)
  const [cachedData, setCachedData] = useState(null)
  const [isIframeMode, setIsIframeMode] = useState(false)

  function queryParamsToJSON(url) {
    const query = url // Get the query string
    const params = new URLSearchParams(query)
    const result = {}

    for (const [key, value] of params) {
      result[key] = value
    }

    return result
  }

  const loadData = async (dashData, dateToFilter, isReference = false) => {
    if (!dashData) return []

    const jsonConfig = JSON.parse(dashData?.config)

    // Verificar se o primeiro item tem um link específico
    if (jsonConfig[0]?.link && !isReference) {
      console.log('🔗 Link específico encontrado:', jsonConfig[0].link)
      // Definir um estado especial para mostrar iframe
      setDw([{ isIframe: true, link: jsonConfig[0].link }])
      setIsIframeMode(true)
      setLoadingData(false)
      return
    }

    let formattedForms = ""
    let formattedFarmers = ""

    let projects = jsonConfig[0]?.projects

    if (projects) {
      jsonConfig.shift()
    }

    if (dashData?.filter) {
      const params = queryParamsToJSON(dashData?.filter) // Get the query string

      if (!isReference && filter?.form?.length > 0) {
        formattedForms = `forms='${filter.form}'`
      } else if (isReference && filter.referenceForm) {
        formattedForms = `forms='${filter.referenceForm}'`
      } else {
        formattedForms = params.formulario ? `forms=${params.formulario}` : ""
      }

      formattedForms = formattedForms[0] !== "&" ? `&${formattedForms}` : formattedForms

      if (params.farmers) {
        formattedFarmers = `&farmers=${params.farmers.replace(" ", "")}`
      }

      formattedForms = formattedForms[0] !== "&" ? `&${formattedForms}` : formattedForms
    } else if (!jsonConfig) {
      return
    }

    if (filter && filter.form && filter.form.length) {
      formattedForms = `&forms=${filter.form.map((form) => `'${form.value}'`).join()}`
    }

    const formattedDate = dateToFilter
      ? `&startDate='${dateToFilter.split("|")[0]}'&endDate='${dateToFilter.split("|")[1]}'`
      : ""

    const formattedProducer = filter.producer.length ? `&farmers=${getIds(filter.producer)}` : ""
    const formattedTec = filter.tec.length ? `&tecs=${getIds(filter.tec)}` : ""

    setLoadingData(true)

    const formattedProjects = `projects=${projects
      ? projects
        .split(",")
        .map((projectId) => `"${projectId}"`)
        .join(",")
      : `"${scope?.id}"`
      }`

    let newDw = await Send.get(
      "/dw/data/content",
      `${formattedProjects}${formattedForms}${formattedDate}${formattedFarmers || formattedProducer
      }${formattedTec}&scopeType=${scopeType}`,
    )

    if (newDw && newDw.length > 0 && jsonConfig) {
      newDw = newDw
        .map((item) => {
          const values = [item.Resposta] //`${item.Resposta}`.split("|") ||

          return values.map((Resposta) => {
            return {
              ...item,
              Resposta,
            }
          })
        })
        .flat()
        .filter((item) => item.Resposta != "Ø")

      const formattedDw = formattDw(
        newDw,
        filter,
        jsonConfig.map((data) => ({
          ...data,
          components: data?.components.map((component) => ({
            ...component,
            fields: [],
            standardDeviation: {
              ...component.standardDeviation,
              value: 0,
            },
          })),
        })),
      )

      if (isReference) {
        setDwReference(formattedDw)
      } else {
        setDw(formattedDw)
      }

      // Salvar cache imediatamente após carregamento
      if (!isReference) {
        // Para dados principais, salvar imediatamente
        saveCachedData(formattedDw, dwReference)
        console.log('💾 Cache salvo - dados principais:', {
          dwLength: formattedDw?.length || 0,
          dwReferenceLength: dwReference?.length || 0
        })
      } else {
        // Para dados de referência, salvar com os dados principais atuais
        saveCachedData(dw, formattedDw)
        console.log('💾 Cache salvo - dados de referência:', {
          dwLength: dw?.length || 0,
          dwReferenceLength: formattedDw?.length || 0
        })
      }
    } else {
      setDw([])
      setDwReference([])
    }

    setLoadingData(false)
  }

  const loadTec = async () => {
    try {
      const response = await Send.get(
        `/users/tec-or-manager/${scope?.id}`,
        `scopeType=${scopeType}&role=technician`,
      )

      if (response && response.length > 0) {
        const formatted = response.map((row) => ({ value: row?.id, label: row?.name }))
        setUsersTec(formatted)
      } else {
        setUsersTec([])
      }
    } catch (error) {
      console.log("Error => ", error)
      customToast("Erro ao carregar técnicos", "error")
    }
  }

  useEffect(() => {
    console.log('🔄 useEffect triggered:', {
      scopeId: scope?.id,
      isInitialLoad,
      dashId
    })

    if (scope?.id && dashId && isInitialLoad) {
      console.log('✅ Iniciando carregamento automático')

      // Primeiro, verificar se é um iframe antes de qualquer coisa
      Send.get(`/projects/${scope.id}/dashboard/${dashId}`).then(async (data) => {
        console.log('📊 Dados recebidos do servidor:', data)

        if (data?.config) {
          const jsonConfig = JSON.parse(data.config)

          // Verificar se o primeiro item tem um link específico
          if (jsonConfig[0]?.link) {
            console.log('🔗 Link específico encontrado:', jsonConfig[0].link)
            setIsIframeMode(true)
            setDw([{ isIframe: true, link: jsonConfig[0].link }])
            setLoadingData(false)
            return
          }
        }

        // Se não é iframe, tentar carregar do cache primeiro
        const hasCachedData = loadCachedData()
        console.log('📦 Cache encontrado:', hasCachedData)

        if (!hasCachedData) {
          // Se não tem cache, carregar dados normalmente
          console.log('🌐 Carregando dados normais...')
          setLoadingData(true)
          await loadData(data, filter.date)

          // Se tem filtro de referência, carregar também
          if (filter.reference || filter.referenceForm) {
            await loadData(data, filter.reference, true)
          }
        }
      }).catch(error => {
        console.error('❌ Erro ao buscar dados:', error)
        setLoadingData(false)
      })

      setIsInitialLoad(false)
    }
  }, [scope?.id, dashId, isInitialLoad])

  // useEffect removido - dados de referência são carregados apenas manualmente

  const toggleModal = (position) => {
    !settingsIsOpen && setCurrentComponent(position)
    setSettingsIsOpen(!settingsIsOpen)
  }

  useEffect(() => {
    if (scope?.id) {
      loadTec()
    }
  }, [scope])

  const handleFilter = (value, name) => setFilter((item) => ({ ...item, [name]: value }))

  // Função para buscar dados manualmente
  const handleSearchData = async () => {
    if (!scope?.id) return

    setLoadingData(true)
    setHasFiltersChanged(false)

    try {
      const data = await Send.get(`/projects/${scope.id}/dashboard/${dashId}`)
      await loadData(data, filter.date)

      // Se tem filtro de referência, carregar também
      if (filter.reference || filter.referenceForm) {
        await loadData(data, filter.reference, true)
      }
    } catch (error) {
      console.log("Erro ao buscar dados:", error)
      setLoadingData(false)
    }
  }

  // Carregar dados do cache se existir
  const loadCachedData = () => {
    try {
      const cachedResults = localStorage.getItem(`dynamicDash_data_${dashId}`)

      if (cachedResults) {
        const parsed = JSON.parse(cachedResults)

        console.log("DSDSD", dw)

        /*         console.log('📦 Cache carregado:', {
                  parsed,
                  dwLength: parsed.dw?.length || 0,
                  dwReferenceLength: parsed.dwReference?.length || 0,
                  hasDwData: Array.isArray(parsed.dw) && parsed.dw.length > 0,
                  hasDwReferenceData: Array.isArray(parsed.dwReference) && parsed.dwReference.length > 0
                }) */

        // Só considerar cache válido se tiver dados principais
        if (Array.isArray(parsed.dw) && parsed.dw.length > 0) {
          setDw(parsed.dw)
          setDwReference(parsed.dwReference || [])
          setCachedData(parsed)
          setLoadingData(false)
          console.log('✅ Cache aplicado com sucesso')
          return true
        } else {
          console.log('⚠️ Cache existe mas dw está vazio, ignorando cache')
          return false
        }
      }
    } catch (error) {
      console.log("Erro ao carregar dados do cache:", error)
    }
    return false
  }

  // Salvar dados no cache
  const saveCachedData = (dwData, dwReferenceData) => {
    try {
      const dataToCache = {
        dw: dwData,
        dwReference: dwReferenceData,
        timestamp: Date.now(),
        filters: filter
      }
      localStorage.setItem(`dynamicDash_data_${dashId}`, JSON.stringify(dataToCache))
      setCachedData(dataToCache)
    } catch (error) {
      console.log("Erro ao salvar dados no cache:", error)
    }
  }

  // Salvar filtros no localStorage sempre que mudarem
  useEffect(() => {
    try {
      localStorage.setItem(`dynamicDash_filters_${dashId}`, JSON.stringify(filter))

      // Se não é carregamento inicial, marcar que filtros mudaram
      if (!isInitialLoad) {
        setHasFiltersChanged(true)
      }
    } catch (error) {
      console.log("Erro ao salvar filtros:", error)
    }
  }, [filter, dashId, isInitialLoad])

  const formatUsers = () => {
    const formattedUsers =
      users &&
      users?.map((user) => {
        return {
          label: user.name,
          value: user.id,
        }
      })

    return formattedUsers
  }

  const handleApplyShortcut = async (selectedShortcut) => {
    setFilter({
      ...filter,
      [isShortcutsModalOpen]: selectedShortcut.formId,
    })
    setIsShortcutsModalOpen(false)
  }

  const handleResetShortcut = (type = "form") => {
    setFilter({
      ...filter,
      [type]: null,
    })
  }

  const handleOpenDashComparison = (component, referenceComponent) => {
    setModalIsOpen(true);

    const currentFields = component?.fields || [];
    const codes = component?.codes || [];
    const referenceFields = referenceComponent?.fields || [];
    const referenceCodes = referenceComponent?.codes || [];

    const unifiedFieldsMap = {};

    // Adiciona um registro no array para a chave
    function addOrUpdateField(key, field, origem) {
      if (!unifiedFieldsMap[key]) {
        unifiedFieldsMap[key] = [];
      }
      unifiedFieldsMap[key].push({ ...field, origem });
    }

    currentFields.forEach((field) => {
      const producerId = field["ProdutorId"] || field["id"];
      const producerName = field["Produtor"] || field["produtor"];
      const key = producerId && producerName ? `${producerId}_${producerName}` : `current_${Date.now()}_${Math.random()}`;
      addOrUpdateField(key, field, "atual");
    });

    referenceFields.forEach((field) => {
      const producerId = field["ProdutorId"] || field["id"];
      const producerName = field["Produtor"] || field["produtor"];
      const key = producerId && producerName ? `${producerId}_${producerName}` : `ref_${Date.now()}_${Math.random()}`;
      addOrUpdateField(key, field, "referência");
    });

    // Agora achatamos para um array único, mantendo todos
    let unifiedFields = Object.values(unifiedFieldsMap).flat();

    // Juntar todos os códigos (pegando só a propriedade 'code')
    const allCodes = [...codes, ...referenceCodes]
      .flat()
      .map((codeObj) => codeObj.code)
      .filter(Boolean);

    // Criar objeto de códigos
    const codesObject = {};
    allCodes.forEach((code, idx) => {
      codesObject[`code_${idx + 1}`] = code;
    });

    // Adicionar códigos a todos os campos
    unifiedFields = unifiedFields.map(field => ({ ...field, ...codesObject }));

    setComparisonFields(unifiedFields);
  }

  return (
    <DynamicDashScreen
      {...{
        handleOpenDashComparison,
        comparisonFields,
        dwComparison,
        modalIsOpen,
        setModalIsOpen,
        dw,
        dwReference,
        loadingData,
        periodOptions,
        dataGroupOptions,
        filter,
        handleFilter,
        settingsIsOpen,
        toggleModal,
        currentComponent,
        isUserAdmin,
        users: formatUsers(),
        usersTec,
        scope,
        isShortcutsModalOpen,
        setIsShortcutsModalOpen,
        shortcuts: shortcuts[scope?.id] || [],
        handleApplyShortcut,
        formsByProject,
        appliedShortcut: {
          form:
            filter?.form &&
            shortcuts[scope?.id] &&
            shortcuts[scope?.id].find((shortcut) => shortcut?.formId === filter?.form)?.title,
          referenceForm:
            filter?.referenceForm &&
            shortcuts[scope?.id] &&
            shortcuts[scope?.id].find((shortcut) => shortcut?.formId === filter?.referenceForm)
              ?.title,
        },
        handleResetShortcut,
        // Novas props para busca manual
        handleSearchData,
        hasFiltersChanged,
        cachedData,
        isIframeMode,
      }}
    />
  )
}

export default DynamicDashContainer
